import { SkuDTO } from '@/types/api/api-v2';

export default async function getRecommendedSkus(): Promise<SkuDTO[]> {
  try {
    const response = await fetch('/api/get-recommended-skus');
    if (!response.ok) {
      throw new Error('Failed to fetch bottle of the day');
    }
    const data = await response.json();
    return data.data;
  } catch (e) {
    throw new Error('Failed to fetch bottle of the day');
  }
}
